<template>
	<SuiIcon
		v-if="syncStatus === SyncStatus.STATUS_SUCCESS"
		data-testid="integration-actions-bubble-icon"
		name="icon-check-filled-16"
		:classes="[`integration-actions-bubble--${props.syncStatus}`]"
	/>

	<div
		v-else
		class="integration-actions-bubble"
		data-testid="integration-actions-bubble"
		:class="[`integration-actions-bubble--${props.syncStatus}`]"
	>
		{{ props.errorCount }}
	</div>
</template>
<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';
import { SyncStatus, type SyncStatusType } from '@/features/Integrations';

export type IntegrationActionsBubbleProps = {
	errorCount?: number;
	syncStatus?: SyncStatusType;
};

const props = defineProps<IntegrationActionsBubbleProps>();
</script>

<style lang="scss">
.integration-actions-bubble {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.5rem;
	min-width: 2rem;
	height: 2rem;
	border-radius: 4rem;
	font-size: 1.25rem;
	font-weight: $scoro-fw-semi-bold;
	background: $neutral-50;
	color: $neutral-00;

	&--status-error {
		background: $red-50;
	}

	&--status-warning {
		background: $orange-50;
	}

	&--status-success {
		--sui-button-icon-color: #{$green-50};
		--sui-button-hover-icon-color: #{$green-50};

		&.sui-icon {
			fill: $green-50;
		}
	}
}
</style>
